export const RELEASE_VERSION: string = 'v.8.1.1';
